import moment from "moment";
import { message } from "ant-design-vue";

export function format(value) {
   
    return moment(value).format("YYYY-MM-DD MM:HH:ss");
};
export function beforeUpload(file) {

    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('You can only upload JPG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
}



export function throttle(fn, wait) {

    let timer;
    return function () {
        if (!timer) {
            timer = setTimeout(() => {
                timer = null;
                fn.apply(this, arguments);
            }, wait)
        }
    }
}

export function debounce(fn, delay = 200) {

	return function(args) {
		//获取函数的作用域和变量
		let that = this
		let _args = {
			...args
		}
		//每次事件被触发，都会清除当前的timeer，然后重写设置超时调用
		clearTimeout(fn.id)
		fn.id = setTimeout(function() {
			fn.call(that, _args)
		}, delay)
	}
}
